export const ORIGIN_CONFIGURABLE_ACTIONS = [
  { key: "extract", defaultLabel: "Shape" },
  { key: "identify_topics", defaultLabel: "Topics" },
  { key: "chat", defaultLabel: "Chat" },
  { key: "edit", defaultLabel: "Edit" },
  { key: "extend", defaultLabel: "Extend" },
] as const;

export type OriginConfigurableActionKey =
  (typeof ORIGIN_CONFIGURABLE_ACTIONS)[number]["key"];

export type OriginActionPresentationInput = {
  color?: string;
  key: string;
  tone?: "default" | "danger";
};

export function getOriginActionColor(action: OriginActionPresentationInput) {
  if (action.tone === "danger") {
    return "moveon.danger";
  }

  if (action.key === "extract") {
    return action.color ?? "moveon.primary";
  }

  return action.color ?? "moveon.surface.fg";
}

export function getOriginActionBorderColor(
  action: OriginActionPresentationInput,
) {
  if (action.tone === "danger") {
    return "moveon.dangerBorder";
  }

  if (action.key === "extract") {
    return action.color ?? "moveon.primary";
  }

  return "moveon.surface.interactiveBorder";
}

export function getOriginActionHoverBg(action: OriginActionPresentationInput) {
  if (action.tone === "danger") {
    return "moveon.dangerLight";
  }

  if (action.key === "extract") {
    return "moveon.primaryLight";
  }

  return "moveon.surface.elevatedBg";
}
